jQuery(document).ready(function(jQuery) {
  var alreadySetToBelowFold = false;
  let icon = document.getElementById("nav-icon");
  let threshold = 400;

  document.getElementById("header-logo").addEventListener("click", function() {
    window.location.href = "/";
  });

  addScrollEvents();

  window.addEventListener("resize", resizeHandler);

  document.getElementById("nav-icon").addEventListener("click", function() {
    document.getElementById("header").style.top = window.scrollY + "px";
    document.body.style.overflow = "hidden";
  });

  // Select the node that will be observed for mutations
  var targetNode = document.querySelector(".off-canvas-content");

  // Options for the observer (which mutations to observe)
  var config = { attributes: true };

  // Callback function to execute when mutations are observed
  var callback = function(mutationsList, observer) {
    for (var mutation of mutationsList) {
      if (mutation.type == "attributes") {
        if (!targetNode.classList.contains("has-transition-push")) {
          console.log("off canvas is now closed");
          console.log("clicked out");
          document.getElementById("header").style.top = 0;
          document.body.style.overflow = "auto";
        }
      }
    }
  };

  // Create an observer instance linked to the callback function
  var observer = new MutationObserver(callback);

  // Start observing the target node for configured mutations
  observer.observe(targetNode, config);

  // Later, you can stop observing
  // observer.disconnect();

  function resizeHandler(e) {
    let width = Math.max(document.body.clientWidth, window.innerWidth || 0);
    if (width < 1027) {
      threshold = 50;
    } else {
      threshold = 400;
    }
  }

  function changeNavBarStyle(e) {
    var scrollTop =
      window.pageYOffset !== undefined
        ? window.pageYOffset
        : (
            document.documentElement ||
            document.body.parentNode ||
            document.body
          ).scrollTop;

    if (scrollTop > threshold) {
      if (!alreadySetToBelowFold) {
        document.getElementById("header").style.backgroundColor = "white";
        document.getElementById("header").style.position = "fixed";
        document.getElementById("header-logo").style.fill = "#231F20";
        document.getElementById("header-logo").classList.add("below-fold");
        document.getElementById("header-menu").classList.add("below-fold-menu");
        document
          .querySelector(".top-bar-right")
          .classList.add("below-fold-links");
        document.getElementById("nav-icon").classList.add("below-fold");

        alreadySetToBelowFold = true;
      }
    } else {
      if (alreadySetToBelowFold) {
        document.getElementById("header").style.backgroundColor = "transparent";
        document.getElementById("header-logo").style.fill = "white";
        document.getElementById("header").style.position = "absolute";
        if (
          document
            .getElementById("header-logo")
            .classList.contains("below-fold")
        ) {
          document.getElementById("header-logo").classList.remove("below-fold");
        }
        if (
          document
            .getElementById("header-menu")
            .classList.contains("below-fold-menu")
        ) {
          document
            .getElementById("header-menu")
            .classList.remove("below-fold-menu");
        }
        if (
          document.getElementById("nav-icon").classList.contains("below-fold")
        ) {
          document.getElementById("nav-icon").classList.remove("below-fold");
        }
        if (
          document
            .querySelector(".top-bar-right")
            .classList.contains("below-fold-links")
        ) {
          document
            .querySelector(".top-bar-right")
            .classList.remove("below-fold-links");
        }
        alreadySetToBelowFold = false;
      }
    }
  }

  function addScrollEvents() {
    let p = window.location.pathname.replace(/\//g, "");
    if (!p) {
      window.addEventListener("scroll", changeNavBarStyle);
    } else {
      document.getElementById("header").style.backgroundColor = "white";
      document.getElementById("header").style.position = "fixed";
      document.getElementById("header-logo").style.fill = "#231F20";
      document.getElementById("header-logo").classList.add("below-fold");
      document.getElementById("header-menu").classList.add("below-fold-menu");
      document
        .querySelector(".top-bar-right")
        .classList.add("below-fold-links");
      document.getElementById("nav-icon").classList.add("below-fold");
    }
  }
});
